import styled from 'styled-components';

import { fonts } from '@dreryk/react-components';

const StyledHistoricalVisitBoldText = styled.div`
   font-weight: ${fonts.fontWeightBold};
`;

StyledHistoricalVisitBoldText.displayName = 'StyledHistoricalVisitBoldText';

export { StyledHistoricalVisitBoldText };
